import type { ChangelogEntry } from "../types";

/** Meld skade, servicesaker og varsler for utstyr. */
export const UTSTYR_SERVICE_2026_10: ChangelogEntry = {
  id: "2026-10-25-utstyr-service",
  date: "2026-10-25",
  title: "Meld skade og følg opp service på utstyr",
  summary:
    "Skader meldes fra utstyrskortet, utstyr som ikke kan brukes settes på service, og utstyrsansvarlige og de som har booket får varsel i Revehiet.",
  sections: [
    {
      heading: "Utstyr",
      minRole: "user",
      items: [
        {
          title: "«Meld skade» på utstyrskortet",
          kind: "nytt",
          featureFlag: "feature_equipment",
          body: "Skriv hva som er galt, legg ved et bilde og velg Brukbar eller Ikke brukbar. Ikke brukbar setter utstyret «På service», så det ikke kan bookes. Utstyrsansvarlige får varsel i Revehiet med en gang.",
        },
        {
          title: "Utstyr, Service",
          kind: "nytt",
          featureFlag: "feature_equipment",
          body: "Alle servicesaker med status Åpen, Hos verksted eller Ferdig, og verksted. Når saken er Ferdig, blir utstyret Tilgjengelig igjen. Bare administratorer ser og setter kostnad.",
        },
        {
          title: "Utstyr på service vises i bookingen",
          kind: "forbedret",
          featureFlag: "feature_equipment",
          body: "Utstyr på service eller savnet dukker opp i søket når du booker, men kan ikke velges, og grunnen står under navnet.",
        },
        {
          title: "Morgenvarsler om utstyr",
          kind: "nytt",
          featureFlag: "feature_equipment",
          body: "Hver morgen får den ansvarlige for en booking varsel når utstyret er på service, og begge ansvarlige får varsel om en ny dobbelbooking. Varslene kommer i bjella, og på e-post for den som har valgt det under Varsler. Samme varsel gis bare én gang.",
        },
        {
          title: "Ny henting av produktdata vises i køen",
          kind: "rettet",
          featureFlag: "feature_equipment",
          body: "Hentes produktdata på nytt for en modell der forrige henting feilet, står modellen nå som «Venter på gjennomsyn» og ikke lenger som «Feilet».",
        },
        {
          title: "Produktlenke på utstyr",
          kind: "nytt",
          featureFlag: "feature_equipment",
          body: "Ved registrering kan du fylle ut merke, modell og produktlenke. Med lenke hentes bilde, manual og spesifikasjoner fra akkurat den siden, og forslaget venter under Produktdata til det godkjennes. Lenken kan også legges inn eller rettes i «Hent produktdata».",
        },
        {
          title: "Store manualer kan lagres",
          kind: "rettet",
          featureFlag: "feature_equipment",
          body: "Manualer og brosjyrer på over 15 MB stoppet lagringen av produktdata. Nå lagres filer opp til 50 MB.",
        },
      ],
    },
  ],
};
